/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/Delete/Content/Main/Content/DeleteAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let deleteTreatmentHasAppointmentsValueData = fromData.useDataValue({ viewPath,
context: 'delete_treatment',
path: 'has_appointments',
})
let deleteTreatmentIsContractAppliedValueData = fromData.useDataValue({ viewPath,
context: 'delete_treatment',
path: 'is_contract_applied',
})
let aggregateData = fromAggregate.none(deleteTreatmentHasAppointmentsValueData, deleteTreatmentIsContractAppliedValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}